import React, { Component } from 'react';
import CreateExtraDelivery from '../components/CreateExtraDelivery'

class ExtraDelivery extends Component{
  constructor() {
    super();
    this.state = {
      carts: [],
      status: false,
      createStatus: false,
    }

    this.toggleCreateDelivery = this.toggleCreateDelivery.bind(this)
    this.setStatusTrue = this.setStatusTrue.bind(this)
  }

  componentDidMount() {
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch("/api/admin/delivery/extra", {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(body => {
            this.setState({...body})
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  toggleCreateDelivery() {
    this.setState(prevState => ({createStatus: !prevState.createStatus}))
  }

  setStatusTrue() {
    this.setState({status: true})
  }

  render() {
    return(
      <div className="Deliveries">
        {
          this.state.createStatus
          ?
          <div className="CreateDelivery-overlay">
            <CreateExtraDelivery
              toggleCreateDelivery={this.toggleCreateDelivery}
              setStatusTrue={this.setStatusTrue}
              />
          </div>
          :
          null
        }
        <h1>Extra Delivery</h1>
        {
          this.state.status
          ?
          <p>A delivery is already in proccess. Wait for it to finish before creating new</p>
          :
          <button
            className="Add-btn"
            onClick={this.toggleCreateDelivery}>
            Create delivery
          </button>
        }
        <div className="Products-body">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Month</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.carts.map((item, idx) => {
                  return(
                    <tr key={idx}>
                      <td>{item.user__first_name} {item.user__last_name}</td>
                      <td>{item.user__email}</td>
                      <td>{item.month__name}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default ExtraDelivery;



// WEBPACK FOOTER //
// ./src/containers/admin/containers/ExtraDelivery.jsx